import { AuthService } from "../shared/types"

export interface AccessService {
  hasAdminAccess(): boolean
}

export function createAccessService(authService: AuthService): AccessService {
  return {
    hasAdminAccess() {
      return authService.getAuthType() === `admin`
    },
  }
}
